import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

import {
  TotalNitrogenLegalNorm,
  GetTotalNitrogenLegalNormsResponse,
  UpsertTotalNitrogenLegalNormResponse,
  TotalNitrogenLegalNormFilter,
  DeleteTotalNitrogenLegalNormResponse,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class TotalNitrogenLegalNormApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/field-report/secure/totalnitrogenlegalnorm';

  getTotalNitrogenLegalNorms(pageNumber: number, pageSize: number, filter: TotalNitrogenLegalNormFilter): Observable<GetTotalNitrogenLegalNormsResponse> {
    let url = `${this.baseUrl}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (filter.year) {
      url += `&calendarYear=${filter.year}`;
    }
    if (filter.cropId) {
      url += `&cropId=${filter.cropId}`;
    }
    return this.http.get<GetTotalNitrogenLegalNormsResponse>(url);
  }

  upsertTotalNitrogenLegalNorm(totalNitrogenLegalNorm: TotalNitrogenLegalNorm) {
    return this.http.post<UpsertTotalNitrogenLegalNormResponse>(this.baseUrl, totalNitrogenLegalNorm, {});
  }

  deleteTotalNitrogenLegalNorm(totalNitrogenLegalNormId: number) {
    return this.http.delete<DeleteTotalNitrogenLegalNormResponse>(this.baseUrl + '/' + totalNitrogenLegalNormId);
  }
}
